export type ColumnStat = {
    index: number;
    /** Primer valor no vacio de la columna, para mostrar como ejemplo. */
    sample: string;
    /** Filas con dato en esta columna. */
    filled: number;
    total: number;
};

/**
 * Resume cada columna del archivo para el paso de mapeo.
 *
 * El ejemplo es el primer valor **no vacio**, no el de la primera fila: los archivos
 * exportados traen columnas con huecos, y mostrar la primera celda hace creer que el
 * mapeo fallo cuando en realidad solo estaba vacio ese registro. En uno de los archivos
 * reales la columna "Nombre" tiene sus primeros 209 registros en blanco.
 *
 * `filled` acompana al ejemplo para que una columna incompleta se vea antes de importar.
 */
export const buildColumnStats = (dataRows: string[][], columnCount: number): ColumnStat[] =>
    Array.from({ length: columnCount }, (_, index) => {
        let sample = "";
        let filled = 0;

        for (const row of dataRows) {
            const value = `${row?.[index] ?? ""}`.trim();
            if (!value) continue;
            filled += 1;
            if (!sample) sample = value;
        }

        return { index, sample, filled, total: dataRows.length };
    });
